import { useState, useEffect } from "react"
import { authFetch } from "../../utils/api"

const API = process.env.REACT_APP_API_URL

const ROL_LABEL = {
  ADMIN: "administrador",
  OBRA_SOCIAL: "obra social",
  OBSERVADOR: "observador",
}

function ListaUsuarios() {
  const [usuarios, setUsuarios] = useState([])
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(null)
  const [editandoId, setEditandoId] = useState(null)
  const [form, setForm] = useState(null)
  const [mensaje, setMensaje] = useState(null)

  const cargarUsuarios = () => {
    setCargando(true)
    authFetch(`${API}/usuarios`)
      .then(res => {
        if (!res.ok) throw new Error()
        return res.json()
      })
      .then(data => setUsuarios(data))
      .catch(() => setError("No se pudo cargar la lista de usuarios"))
      .finally(() => setCargando(false))
  }

  useEffect(() => { cargarUsuarios() }, [])

  const handleEditar = (u) => {
    if (editandoId === u.id) {
      setEditandoId(null)
      setForm(null)
      setMensaje(null)
      return
    }
    setEditandoId(u.id)
    setMensaje(null)
    setForm({
      cuit: u.cuit || "",
      email: u.email || "",
      password: "",
      confirmar: "",
      obraSocialNombre: u.obraSocial?.nombre || "",
      role: u.role,
    })
  }

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleGuardar = async () => {
    setMensaje(null)
    if (form.password && form.password !== form.confirmar) {
      setMensaje({ tipo: "error", texto: "Las contraseñas no coinciden" })
      return
    }
    try {
      const body = {
        cuit: form.cuit,
        email: form.email || null,
        ...(form.password && { password: form.password }),
        ...(form.role === "OBRA_SOCIAL" && { obraSocialNombre: form.obraSocialNombre }),
      }
      const res = await authFetch(`${API}/usuarios/${editandoId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
      if (!res.ok) {
        const err = await res.json()
        setMensaje({ tipo: "error", texto: err.error || "Error al guardar" })
        return
      }
      setMensaje({ tipo: "ok", texto: "Usuario actualizado correctamente" })
      cargarUsuarios()
    } catch {
      setMensaje({ tipo: "error", texto: "Error de conexión" })
    }
  }

  return (
    <div className="adminPanel column">
      <div className="adminPanelTitle row">
        <i className="fa-solid fa-users"></i>
        USUARIOS DEL SISTEMA
      </div>

      <div className="adminPreviewBox">
        {cargando && (
          <div className="adminEmptyState">cargando...</div>
        )}

        {error && (
          <div className="adminMensaje adminMensaje--error">{error}</div>
        )}

        {!cargando && !error && usuarios.length === 0 && (
          <div className="adminEmptyState">no hay usuarios registrados</div>
        )}

        {!cargando && !error && usuarios.length > 0 && (
          <table className="adminPreviewTable">
            <thead>
              <tr>
                <th style={{ width: 32 }}></th>
                <th>cuit</th>
                <th>email</th>
                <th>rol</th>
                <th>obra social</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <>
                  <tr key={u.id} className={editandoId === u.id ? "usuarioRowActiva" : ""}>
                    <td>
                      <button
                        className={`usuarioEditBtn${editandoId === u.id ? " usuarioEditBtn--active" : ""}`}
                        onClick={() => handleEditar(u)}
                        title="editar usuario"
                      >
                        <i className={`fa-solid fa-${editandoId === u.id ? "xmark" : "pen"}`}></i>
                      </button>
                    </td>
                    <td>{u.cuit}</td>
                    <td>{u.email || <span className="adminPlaceholder">—</span>}</td>
                    <td>
                      <span className={`usuarioRolBadge usuarioRolBadge--${u.role.toLowerCase()}`}>
                        {ROL_LABEL[u.role] ?? u.role}
                      </span>
                    </td>
                    <td>{u.obraSocial?.nombre || <span className="adminPlaceholder">—</span>}</td>
                  </tr>

                  {editandoId === u.id && form && (
                    <tr key={`${u.id}-form`} className="usuarioFormRow">
                      <td colSpan={5}>
                        <div className="usuarioFormInline">

                          <div className="adminSection">
                            <div className="adminSectionLabel">datos de acceso</div>
                            <div className="adminRow">
                              <div className="adminField">
                                <label>cuit</label>
                                <input type="text" name="cuit" value={form.cuit} onChange={handleChange} style={{ width: 160 }} />
                              </div>
                              <div className="adminField">
                                <label>email</label>
                                <input type="email" name="email" placeholder="correo electrónico" value={form.email} onChange={handleChange} style={{ width: 180 }} />
                              </div>
                              {form.role === "OBRA_SOCIAL" && (
                                <div className="adminField">
                                  <label>obra social</label>
                                  <input type="text" name="obraSocialNombre" value={form.obraSocialNombre} onChange={handleChange} style={{ width: 200 }} />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="adminSection">
                            <div className="adminSectionLabel">cambiar contraseña</div>
                            <div className="adminRow">
                              <div className="adminField">
                                <label>nueva contraseña</label>
                                <input type="password" name="password" placeholder="dejar vacío para no cambiar" value={form.password} onChange={handleChange} style={{ width: 170 }} />
                              </div>
                              <div className="adminField">
                                <label>confirmar</label>
                                <input type="password" name="confirmar" placeholder="repetir contraseña" value={form.confirmar} onChange={handleChange} style={{ width: 150 }} />
                              </div>
                            </div>
                          </div>

                          {mensaje && (
                            <div className={`adminMensaje adminMensaje--${mensaje.tipo}`}>
                              {mensaje.texto}
                            </div>
                          )}

                          <div className="adminBtnRow">
                            <button className="adminBtn adminBtn--primary" onClick={handleGuardar}>guardar cambios</button>
                            <button className="adminBtn" onClick={() => { setEditandoId(null); setForm(null); setMensaje(null) }}>cancelar</button>
                          </div>

                        </div>
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default ListaUsuarios
